import React from "react";
import WordTetris from "./game";
import "./styles.css";
import { Toaster } from "./components/ui/sonner";

export default function App() {
  return (
    <div>
      <WordTetris />
      <Toaster />
    </div>
  );
}
